import { render, staticRenderFns } from "./Commission_ItemsTable.vue?vue&type=template&id=4dca1954&scoped=true&"
import script from "./Commission_ItemsTable.vue?vue&type=script&lang=js&"
export * from "./Commission_ItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./Commission_ItemsTable.vue?vue&type=style&index=0&id=4dca1954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca1954",
  null
  
)

export default component.exports